import { FC, useRef } from "react";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Studio } from "./pages/Studio";
import { Projekte } from "./pages/Projekte";
import { About } from "./pages/About";
import { Team } from "./pages/Team";
import { Jobs } from "./pages/Jobs";
import { Kontakt } from "./pages/Kontakt";
import { Footer } from "./components/Footer";
import styled from "@emotion/styled";
import { Awards } from "./pages/Awards";
import Showreels from "./components/Showreels";
import { useMobile } from "./MobileProvider";

const AppWrapper = styled("div")(() => ({
  width: "100%",
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  overflowX: "hidden",
}));

const Home: FC = () => {
  const mobile = useMobile();
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const studioRef = useRef<HTMLDivElement | null>(null);
  const projekteRef = useRef<HTMLDivElement | null>(null);
  const aboutRef = useRef<HTMLDivElement | null>(null);
  const jobsRef = useRef<HTMLDivElement | null>(null);
  const teamRef = useRef<HTMLDivElement | null>(null);
  const kontaktRef = useRef<HTMLDivElement | null>(null);

  return (
    <AppWrapper ref={wrapperRef}>
      <Header
        studioRef={studioRef}
        projekteRef={projekteRef}
        aboutRef={aboutRef}
        jobsRef={jobsRef}
        teamRef={teamRef}
        kontaktRef={kontaktRef}
      />
      <Hero aboutRef={aboutRef} projekteRef={projekteRef} />
      <Awards />
      {!mobile && (
        <Showreels
          handleNavigateProjekte={() => {
            if (projekteRef.current) {
              projekteRef.current.scrollIntoView({ behavior: "smooth" });
            }
          }}
        />
      )}
      <Projekte ref={projekteRef} />
      <Studio ref={studioRef} />
      <About ref={aboutRef} />
      <Team
        handleKontaktformular={() => {
          if (kontaktRef) {
            kontaktRef.current?.scrollIntoView({ behavior: "smooth" });
          }
        }}
        ref={teamRef}
      />
      <Jobs
        handleKontaktformular={() => {
          if (kontaktRef) {
            kontaktRef.current?.scrollIntoView({ behavior: "smooth" });
          }
        }}
        ref={jobsRef}
      />
      <Kontakt ref={kontaktRef} />
      <Footer />
    </AppWrapper>
  );
};

export default Home;
